import React from 'react';
import { Multiselect } from 'multiselect-react-dropdown';
import i18next from 'i18next';

import { SIDEBAR_ORDER_CUISINE_LIST } from './cuisines';
import CommonSection from '../common/CommonSection';

export type CuisineListSelectProps = {
  handleChange: (newCuisineLabels: string[]) => void;
  values: string[];
};

const CuisineListSelect: React.FC<CuisineListSelectProps> = ({
  handleChange,
  values,
}) => {
  return (
    <CommonSection header={i18next.t('cuisine-list-select.header')}>
      <Multiselect
        isObject={false}
        options={SIDEBAR_ORDER_CUISINE_LIST}
        onSelect={handleChange}
        onRemove={handleChange}
        selectedValues={values}
        selectionLimit={5}
        showCheckbox
        placeholder={i18next.t('cuisine-list-select.placeholder')}
      />
      <p className="text-danger mt-3 mb-0">
        {i18next.t('cuisine-list-select.notice')}
      </p>
    </CommonSection>
  );
};

export default CuisineListSelect;
